<template>
  <div class="w-full h-full">
    <!-- <div v-if="loader == true" class="w-full h-full"></div> -->
    <form 
      @submit.prevent="submitBasicDetails"
      @click.stop
      class="w-full h-auto bg-primary2 p-5"
    >
      <div class="flex flex-col gap-3 lg:gap-5">
        <div class="flex flex-col gap-3">
          <div class="flex justify-between items-center">
            <h2 class="text-xl font-semibold text-heading">Program Details</h2>
            <div>
              <button
                v-if="toggle_edit == true"
                @click="
                  disableStatus = true;
                  submitAdditional = true;
                  toggle_edit = false;
                "
                type="button"
                class="px-5 py-1 btn text-[16px] rounded-md"
              >
                Close
              </button>
              <button
                v-if="submitAdditional == true"
                @click="toggleEdit"
                type="button"
                class="px-5 py-1 btn text-[16px] rounded-md"
              >
                Edit
              </button>
            </div>
          </div>
          <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
            <div class="w-full flex flex-col gap-3">
              <label for="program" class="text-sm input_label"
                >Program <span class="span-color">*</span></label
              >
              <select
                :disabled="disableStatus"
                class="block w-full py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                v-model="selectedProgram"
              >
                <option value="" selected disabled>Program</option>
                <option
                  v-for="program in programs"
                  :key="program.id"
                  :value="program.name"
                >
                  {{ program.name }}
                </option>
              </select>
            </div>
            <div class="w-full flex flex-col gap-3">
              <label for="elective" class="text-sm input_label"
                >Electives <span class="span-color">*</span></label
              >
              <select
                :disabled="disableStatus"
                id="elective_val"
                class="block w-full pl-3 pr-10 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                aria-label="Default select example"
                required
                :class="{
                  'cursor-not-allowed bg-disable': disableStatus === true,
                  'cursor-pointer bg-primary2': disableStatus === false,
                }"
                v-model="selectedElective"
              >
                <option value="" selected disabled>Elective</option>
                <option
                  v-for="elective in filteredElectives"
                  :key="elective.id"
                  :value="elective.name"
                >
                  {{ elective.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- personal details  -->
        <div class="flex flex-col gap-2">
          <h2 class="text-xl font-semibold text-heading">Personal Details</h2>
          <div class="flex flex-col gap-3 lg:gap-5">
            <div
              class="flex flex-col w-full gap-3 lg:flex-row lg;justify-between"
            >
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Name as per 10th mark sheet
                  <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  id="name"
                  v-model="marsheet_name"
                  placeholder="Name"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="email" class="text-sm input_label"
                  >Email Address <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="email"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  id="email"
                  v-model="email"
                  placeholder="Email"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="phone_number" class="text-sm input_label"
                  >Registered Mobile Number
                  <span class="span-color">*</span></label
                >
                <div class="flex">
                  <select
                    :disabled="disableStatus"
                    id="country-form"
                    v-model="selectedCountryCode"
                    @change="handleChange"
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    required
                    class="form-control block w-20 px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  >
                    <option
                      v-for="country in countryCodes"
                      :key="country.code"
                      :value="country.code"
                    >
                      {{
                        selectedCountryCode === country.code
                          ? country.code
                          : `${country.name} (${country.code})`
                      }}
                    </option>
                  </select>
                  <input
                    :disabled="disableStatus"
                    type="tel"
                    class="form-control block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    id="Phone_no"
                    placeholder="Phone no*"
                    maxlength="10"
                    v-model="phone_number"
                    required
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                  />
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="program" class="text-sm input_label"
                  >Date of Birth <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="date"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="date_of_month"
                  placeholder="CA Registration Number"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Gender <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  id="elective_val"
                  class="block w-full text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  v-model="selectedGender"
                >
                  <option value="" selected disabled>Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Nationality <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  id="elective_val"
                  class="block w-full text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  v-model="selected_nationality"
                >
                  <option value="" selected disabled>Select Nationality</option>
                  <option value="Indian">Indian</option>
                  <option value="Non Indian">Non Indian</option>
                  <option value="Other">Others</option>
                </select>
              </div>
            </div>
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="phone_number" class="text-sm input_label"
                  >Alternate Mobile Number
                  <span class="span-color">*</span></label
                >
                <div class="flex">
                  <select
                    :disabled="disableStatus"
                    id="country-form"
                    v-model="selectedCountryCode"
                    @change="handleChange"
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                    required
                    class="form-control block w-20 px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  >
                    <option
                      v-for="country in countryCodes"
                      :key="country.code"
                      :value="country.code"
                    >
                      {{
                        selectedCountryCode === country.code
                          ? country.code
                          : `${country.name} (${country.code})`
                      }}
                    </option>
                  </select>
                  <input
                    :disabled="disableStatus"
                    type="tel"
                    class="form-control block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    id="Phone_no"
                    placeholder="Alternate Phone no*"
                    maxlength="10"
                    v-model="alternate_phone_number"
                    required
                    :class="{
                      'cursor-not-allowed bg-disable': disableStatus === true,
                      'cursor-pointer bg-primary2': disableStatus === false,
                    }"
                  />
                </div>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Highest Education Qualification
                  <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  id="qualification_val"
                  v-model="highest_qualification"
                  class="form-select appearance-none block w-full pl-3 pr-10 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>
                    Highest Qualification*
                  </option>
                  <option
                    v-for="qualification in qualifications"
                    :key="qualification"
                    :value="qualification.id"
                  >
                    {{ qualification.name }}
                  </option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Highest Education Location - Country
                  <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  id="elective_val"
                  class="block w-full text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  v-model="highest_qualification_college_location"
                >
                  <option value="" selected disabled>Select Country</option>
                  <option value="canada">Canada</option>
                  <option value="indian">India</option>
                  <option value="russia">Russia</option>
                  <option value="usa">USA</option>
                  <option value="uk">UK</option>
                </select>
              </div>
            </div>
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Are You Physically Challenged?
                  <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  id="physically_challenged"
                  v-model="physically_challenged"
                  class="form-select appearance-none block w-full pl-3 pr-10 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>
                    Are You Physically Challenged
                  </option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Are You Eligible For Military Scholarship?
                  <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  id="military_scholarship"
                  class="block w-full text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  v-model="military_scholarship"
                >
                  <option value="" selected disabled>
                    Are You Eligible For Military Scholarship
                  </option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <!-- <label for="name"  class="text-sm input_label"
                  >Aadhar Number <span class="span-color">*</span></label
                >
                <input :disabled="disableStatus"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0  input-border rounded-md shadow-md focus:outline-none"
                  id="aadhar"
                  v-model="aadhar_num"
                  placeholder="Aadhar Number"
                  required
                  :class="{ 
                    'cursor-not-allowed bg-disable':disableStatus===true,
                    'cursor-pointer bg-primary2':disableStatus===false,
                   }"
                /> -->
              </div>
            </div>
            <div class="flex flex-col gap-3 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Current College <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="current_college"
                  placeholder="Enter Your College Name"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                />
                <!-- <select
                  :disabled="disableStatus"
                  id="qualification_val"
                  v-model="current_college"
                  class="form-select appearance-none block w-full pl-3 pr-10 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>Select College</option>
                  <option value="abc_college">ABC college</option>
                  <option value="galecta_college">Galect College</option>
                </select> -->
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Location Of Current College
                  <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="current_college_location"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>
                    Select Current College Location
                  </option>
                  <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3"></div>
            </div>
          </div>
        </div>
        <!-- address for communication  -->
        <div class="flex flex-col gap-2">
          <h2 class="text-xl font-semibold text-heading">
            Address For Correspondence
          </h2>
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-2 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Country <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="selected_address_country"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>Select Country</option>
                  <!-- <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option> -->
                  <option value="canada">Canada</option>
                  <option value="indian">India</option>
                  <option value="russia">Russia</option>
                  <option value="usa">USA</option>
                  <option value="uk">UK</option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >State <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="selected_address_state"
                  @change="onStateChange"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>Select State</option>
                  <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >District <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="selected_address_district"
                  required
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                >
                  <option value="" selected disabled>Select District</option>
                  <option v-for="city in cities" :key="city" :value="city">
                    {{ city }}
                  </option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >City/Town <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="selected_address_city"
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  required
                >
                  <option value="" selected disabled>Select City</option>
                  <option v-for="city in cities" :key="city" :value="city">
                    {{ city }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex flex-col gap-2 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Address Line 1 <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="address_one"
                  placeholder="Address"
                  required
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Address Line 2 <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="address_two"
                  placeholder="Address"
                  required
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Pincode/Zipcode <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  :class="{
                    'cursor-not-allowed bg-disable': disableStatus === true,
                    'cursor-pointer bg-primary2': disableStatus === false,
                  }"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="pincode"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  maxlength="6"
                  placeholder="pincode/zipcode"
                  required
                />
                <p class="text-[11px] text-gray-500">
                  In case your country doen't have pincode/zipcode enter 0
                </p>
              </div>
            </div>
            <div class="flex flex-col gap-2 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >is permanent address same as address for communication?
                  <span class="span-color">*</span></label
                >
                <!-- <div class="flex gap-3 items-center text-sm text-gray-500">
                  <input :disabled="disableStatus"
                    type="radio"
                    @click="assignAddress"
                    id="permanent_address"
                    name="adddress"
                    value="true"
                  />Yes
                  <input :disabled="disableStatus"
                    type="radio"
                    id="communication_address"
                    name="adddress"
                    @click="permanent_address = true"
                    value="false"
                  />No
                </div> -->
                <div class="flex gap-3 items-center text-sm text-gray-500">
                  <input
                    :disabled="disableStatus"
                    type="radio"
                    v-model="permanent_address"
                    id="permanent_address"
                    name="adddress"
                    :value="true"
                  />Yes
                  <input
                    :disabled="disableStatus"
                    type="radio"
                    v-model="permanent_address"
                    id="communication_address"
                    name="adddress"
                    :value="false"
                  />No
                </div>
              </div>
            </div>
            <div
              v-if="permanent_address1 == false"
              class="flex flex-col gap-2 lg:flex-row lg:justify-between"
            >
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >Country <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="permanent_selected_address_country"
                  required
                >
                  <option value="" selected disabled>Select Country</option>
                  <!-- <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option> -->
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >State <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="permanent_selected_address_state"
                  required
                >
                  <option value="" selected disabled>Select State</option>
                  <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >District <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="permanent_selected_address_district"
                  required
                >
                  <option value="" selected disabled>Select District</option>
                  <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option>
                </select>
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="elective" class="text-sm input_label"
                  >City/Town <span class="span-color">*</span></label
                >
                <select
                  :disabled="disableStatus"
                  class="block w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding bg-no-repeat focus:ring-0 input-border rounded shadow-md focus:outline-none"
                  aria-label="Default select example"
                  v-model="permanent_selected_address_city"
                  required
                >
                  <option value="" selected disabled>Select City</option>
                  <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="permanent_address1 == false"
              class="flexflex-col gap-2 lg:flex-row lg:justify-between hidden"
            >
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Address Line 1 <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="permanent_address_one"
                  placeholder="Permanent Address"
                  required
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Address Line 2 <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="permanent_address_two"
                  placeholder="Permanent Address"
                  required
                />
              </div>
              <div class="w-full flex flex-col gap-3">
                <label for="name" class="text-sm input_label"
                  >Pincode/Zipcode <span class="span-color">*</span></label
                >
                <input
                  :disabled="disableStatus"
                  type="text"
                  class="w-full px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 input-border rounded-md shadow-md focus:outline-none"
                  v-model="permanent_pincode"
                  placeholder="pincode/zipcode"
                  required
                />
                <p class="text-[11px] text-gray-500">
                  In case your country doen't have pincode/zipcode enter 0
                </p>
              </div>
            </div>
            <!-- <div class="flex flex-col gap-2 lg:flex-row lg:justify-between">
              <div class="w-full flex flex-col gap-3">
                <label for="name"  class="text-sm input_label"
                  >i acknowledge that this application form for june 2025. i
                  accept that the registration fee is non-refundable

                  <span class="span-color">*</span></label
                >
                <div class="flex gap-3 items-center text-sm text-gray-500">
                  <input :disabled="disableStatus"
                    type="checkbox"
                    name="adddress"
                    class="outline-none focus:outline-none"
                  />I Agree
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div v-if="submit_button == false" class="flex justify-between w-full">
          <div class="text-success text-xl">
            <p v-if="message">{{ message }}</p>
            <p v-if="error_message">{{ error_message }}</p>
          </div>
          <div class="flex justify-end items-center">
            <button
              :disabled="disableStatus"
              :class="{
                'cursor-not-allowed bg-disable dark_text': disableStatus === true,
                'cursor-pointer btn': disableStatus === false,
              }"
              type="submit"
              class="px-5 py-1 text-[16px] rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import stateMixins from "@/mixins/stateMixins";
import countryCodeMixins from "@/mixins/countryCodeMixins";
export default {
  name: "BasicView",
  props: ["complete_status"],
  data() {
    return {
      programs: [],
      electives: [],
      filteredElectives: [],
      qualifications: [],
      cities: [],
      states: "",
      marsheet_name: "",
      email: "",
      selectedProgram: "",
      selectedElective: "",
      selectedCountryCode: "+91",
      selectedGender: "",
      date_of_month: "",
      phone_number: "",
      alternate_phone_number: "",
      selected_nationality: "",
      highest_qualification: "",
      aadhar_num: "",
      selected_state: "",
      highest_qualification_college_location: "",
      current_college_location: "",
      current_college: "",
      physically_challenged: "",
      military_scholarship: "",
      selected_address_country: "",
      selected_address_state: "",
      selected_address_district: "",
      selected_address_city: "",
      address_one: "",
      address_two: "",
      pincode: "",
      permanent_selected_address_country: "",
      permanent_selected_address_state: "",
      permanent_selected_address_district: "",
      permanent_selected_address_city: "",
      permanent_address_one: "",
      permanent_address_two: "",
      permanent_pincode: "",
      permanent_address: true,
      selected_precentage: "",
      basic_data: [],
      submitAdditional: false,
      disableStatus: false,
      get_basic_data: [],
      message: "",
      submit_button: false,
      toggle_edit: false,
      permanent_address1: true,
      error_message: "",
      loader:true,
    };
  },
  mixins: [stateMixins, countryCodeMixins],
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  async created() {
    await this.fetchPrograms();
    await this.fetchElectives();
    await this.qualificationList();
    await this.getBasicDetails();
  },
  methods: {
    // fileSubmission() {
    //   console.log("this.complete_status", this.complete_status);
    //   if (this.complete_status == true) {
    //     this.submitAdditional = false;
    //   }
    // },
    async fetchPrograms() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/program/list/?Key=${this.userInfo.data.token}`
        );
        this.programs = response.data.data;
      } catch (error) {
        console.error("Error fetching programs:", error);
      }
    },
    async fetchElectives() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/elective/list/?Key=${this.userInfo.data.token}`
        );
        this.electives = response.data.data;
      } catch (error) {
        console.error("Error fetching electives:", error);
      }
    },
    filterElectives() {
      if (this.selectedProgram) {
        this.filteredElectives = this.electives.filter(
          (elective) => elective.program.name === this.selectedProgram
        );
      } else {
        this.filteredElectives = [];
      }
    },
    async qualificationList() {
      await axios
        .get(`${process.env.VUE_APP_API}/highest-qualification-list/`)
        .then((resp) => {
          this.qualifications = resp.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // assignAddress() {
    //   this.permanent_selected_address_country = this.selected_address_country;
    //   this.permanent_selected_address_state = this.selected_address_state;
    //   this.permanent_selected_address_district = this.selected_address_district;
    //   this.permanent_selected_address_city = this.selected_address_city;
    //   this.permanent_address_one = this.address_one;
    //   this.permanent_address_two = this.address_two;
    //   this.permanent_pincode = this.pincode;
    //   this.permanent_address = false;
    // },
    submitBasicDetails() {
      const basicData = {
        program: this.selectedProgram,
        elective: this.selectedElective,
        name_as_per_10th: this.marsheet_name,
        email: this.email,
        country_code: this.selectedCountryCode,
        phone: this.phone_number,
        dob: this.formatDate(this.date_of_month),
        gender: this.selectedGender,
        nationality: this.selected_nationality,
        alter_ph_number: this.alternate_phone_number,
        highest_qualification: this.highest_qualification,
        highest_qualifi_location: this.highest_qualification_college_location,
        physically_challenged: this.physically_challenged,
        eligible_military: this.military_scholarship,
        current_college: this.current_college,
        location_of_college: this.current_college_location,
        country: this.selected_address_country,
        state: this.selected_address_state,
        district: this.selected_address_district,
        city: this.selected_address_city,
        address_line1: this.address_one,
        address_line2: this.address_two,
        pincode: this.pincode,
        is_permanent_same_as_present_address: this.permanent_address,
      };
      if (this.toggle_edit == false) {
        axios
          .post(
            `${process.env.VUE_APP_API}/basic-information-create/?Key=${this.userInfo.data.token}`,
            basicData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              this.disableStatus = true;
              this.submitAdditional = true;
              this.getBasicDetails();
              this.$emit("formCompleted");
              setTimeout(() => {
                this.message = "";
              }, 3000);
            } else if (resp.data.status == 400) {
              this.error_message = resp.data.message;
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      } else {
        axios
          .put(
            `${process.env.VUE_APP_API}/basic-information-update-retrieve/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`,
            basicData
          )
          .then((resp) => {
            if (resp.data.status == 200) {
              this.message = resp.data.message;
              setTimeout(() => {
                this.message = "";
              }, 3000);

              // this.disableStatus = true;
              this.toggle_edit = false;
              this.submitAdditional = true;
              this.getBasicDetails();
              this.$emit("formCompleted");
            } else if (resp.data.status == 400) {
              this.error_message = resp.data.message;
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },
    onStateChange() {
      const state = this.stateList.find(
        (s) => s.state === this.selected_address_state
      );
      this.cities = state ? state.districts : [];
      this.selected_address_district = "";
      this.selected_address_city = "";
    },
    formatDate(dateString) {
      if (!dateString) return "Invalid Date";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    getBasicDetails() {
      axios
        .get(
          `${process.env.VUE_APP_API}/basic-information-update-retrieve/${this.userInfo.data.user.id}/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status === 200) {
            const details = resp.data.data;
            this.loader = false;
            if (details.user != null) {
              this.get_basic_data = details;
              this.selectedProgram =
                this.get_basic_data.program || details.program;
              this.selectedElective =
                this.get_basic_data.elective || details.elective;
              this.marsheet_name =
                this.get_basic_data.name_as_per_10th ||
                details.name_as_per_10th;
              this.email = this.get_basic_data.email || details.email;
              this.selectedCountryCode =
                this.get_basic_data.country_code || details.country_code;
              this.phone_number = this.get_basic_data.phone || details.phone;
              this.date_of_month = this.get_basic_data.dob || details.dob;
              this.selectedGender =
                this.get_basic_data.gender || details.gender;
              this.selected_nationality =
                this.get_basic_data.nationality || details.nationality;
              this.alternate_phone_number =
                this.get_basic_data.alter_ph_number || details.alter_ph_number;
              this.highest_qualification =
                this.get_basic_data.highest_qualification ||
                details.highest_qualification;
              this.highest_qualification_college_location =
                this.get_basic_data.highest_qualifi_location ||
                details.highest_qualifi_location;
              this.physically_challenged =
                this.get_basic_data.physically_challenged ||
                details.physically_challenged;
              this.military_scholarship =
                this.get_basic_data.eligible_military ||
                details.eligible_military;
              this.current_college =
                this.get_basic_data.current_college || details.current_college;
              this.current_college_location =
                this.get_basic_data.location_of_college ||
                details.location_of_college;
              this.selected_address_country =
                this.get_basic_data.country || details.country;
              this.selected_address_state =
                this.get_basic_data.state || details.state;
              this.onStateChange();
              this.selected_address_district =
                this.get_basic_data.district || details.district;
              this.selected_address_city =
                this.get_basic_data.city || details.city;
              this.address_one =
                this.get_basic_data.address_line1 || details.address_line1;
              this.address_two =
                this.get_basic_data.address_line2 || details.address_line2;
              this.pincode = this.get_basic_data.pincode || details.pincode;
              this.permanent_address =
                this.get_basic_data.is_permanent_same_as_present_address ||
                details.is_permanent_same_as_present_address;
              // if (
              //   this.get_basic_data.is_form_completed &&
              //   this.get_basic_data.is_form_one_filled
              // ) {
              //   console.log("true true");
              //   this.submitAdditional = false;
              //   this.toggle_edit = false;
              //   this.disableStatus = true;
              //   this.submit_button = true;
              // } else if (
              //   this.get_basic_data.is_form_completed != true &&
              //   this.get_basic_data.is_form_one_filled == true
              // ) {
              //   this.toggle_edit = false;
              //   this.submitAdditional = true;

              //   this.disableStatus = true;
              // } else {
              //   this.submitAdditional = false;
              //   this.disableStatus = false;
              // }
              if(this.get_basic_data.is_form_one_filled ==true){
                this.submitAdditional = true;
                this.disableStatus = true;
                this.toggle_edit = false;
              }
            }
          }else{
            this.loader = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    toggleEdit() {
      this.disableStatus = false;
      this.submitAdditional = false;
      this.toggle_edit = true;
    },
  },
  watch: {
    selectedProgram() {
      this.filterElectives();
    },
  },
};
</script>

<style></style>
